module.exports = __webpack_public_path__ + "img/hic-digestive-diseases-female.61b6b879.png";